/* eslint-disable max-lines-per-function */
export default function loadJS(url, async = false, defer = false) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.crossorigin = "true";

    if (script.readyState) {
      script.onreadystatechange = () => {
        if (["loaded", "complete"].includes(script.readyState)) {
          script.onreadystatechange = null;
          resolve();
        }
      };
    } else {
      script.onload = resolve;
    }

    script.onerror = reject;
    script.src = url;
    if (async) {
      script.async = true;
    }
    if (defer) {
      script.defer = true;
    }

    document.body.appendChild(script);
  });
}
